import React, { PropTypes } from 'react';

import { NitroModal, NitroParagraph } from 'nitro-components';

const DeleteConfirm = ({ action, onCancel, isOpen }) => (
  <NitroModal title="Delete report" isOpen={isOpen} close={onCancel} action={action}>
    <NitroParagraph align="center">Do you want to delete this report ?</NitroParagraph>
    <NitroParagraph align="center">If you delete, this report will be deleted permanently.</NitroParagraph>
  </NitroModal>
);

DeleteConfirm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired
};

export default DeleteConfirm;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/report-edit/components/DeleteConfirm.js